
(function routeTranslatorConfiguration() {

    'use strict';

    // Este objeto será usado para guardar el template cache,
    // ya que este no se encuentra disponible en la etapa de configuración.
    var gTemplateCache = null;

    var stateProvider = null;
    /*
    Este servicio permite definir rutas que cargan el archivo de traducción automáticamente en
    base al nombre del estado.
    */
    angular.module('RouteTranslator', ['ui.router', 'Language'])
        .service('translateRoute', [
            'language', function translateRoute(language) {

                if (language.partialLoading()) {
                    this.getTranslatedRoute = function translatedState(state, obj) {

                        if (obj.resolve == null)
                            obj.resolve = {};

                        obj.resolve.translate = [
                            '$translate', '$translatePartialLoader',
                            function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart(this.self.translateRoute || this.self.name);

                                return $translate.refresh();
                            }
                        ];

                        stateProvider.state(state, obj);
                    };
                } else {
                    // no hago nada pues ya fue cargado todo el archivo de lenguaje.
                    this.getTranslatedRoute = function translatedState() {};
                }
            }
        ])
        .config([
            '$stateProvider', function($stateProvider) {
                stateProvider = $stateProvider;
            }
        ])
        .run([
            '$rootScope', '$templateCache', function($rootScope, $templateCache) {
                gTemplateCache = $templateCache;
            }
        ]);
})();